<template>
  <el-empty v-if="!loading && !parcel" description="没有找到订单信息..." />
  <div v-else class="wrap">
    <!--操作提示区-->
    <div class="tip primary">
      <dl>
        <dt class="text-bold">
          <i class="el-icon-bell" />
          操作提示
        </dt>
        <dd class="text-info">页面打印建议：根据数据行数量，A4纵向打印/A5横向打印。</dd>
      </dl>
      <div class="btns">
        <el-link type="primary" @click="drawer = !drawer">操作记录</el-link>
        <el-link type="primary" v-print="printObj">打印[{{ parcel.Printime }}次]</el-link>
      </div>
    </div>
    <div class="paper">
      <!--打印区-->
      <table id="print">
        <thead>
          <tr>
            <td colspan="8" class="title">
              <vue-qr v-if="parcel.Code" class="qr" :margin="0" :text="parcel.Code" :size="64" />
              <div class="text-center">
                <h1>{{ $utils.meta.format('courier', parcel.Courier) }}发货清单</h1>
                <label class="text-lg text-danger" v-if="parcel.Code">NO.{{ parcel.Code }}</label>
              </div>
              <div class="parcel">
                <ul>
                  <li>
                    <label>客户名称：</label>
                    <label>{{ parcel.CustomerName }}</label>
                  </li>
                  <li>
                    <label>联系人：</label>
                    <label>{{ parcel.Linkman }}</label>
                    <label>联系电话：</label>
                    <label style="white-space: nowrap">{{ parcel.Linktel }}</label>
                  </li>
                  <li>
                    <label>收货地址：</label>
                    <label>{{ parcel.Address }}</label>
                  </li>
                </ul>
                <ul>
                  <li style="white-space: nowrap">
                    <label>时间：</label>
                    <label>{{ $utils.common.parseTime(parcel.CreateTime, '{y} 年 {m} 月 {d} {h}:{i}') }}</label>
                    <label>{{ parcel.StateText }}</label>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>存货编码</th>
            <th colspan="4">品名及规格</th>
            <th>单位</th>
            <th>数量</th>
            <th>订单编号</th>
          </tr>
          <template v-for="(item, index) in parcel.Items">
            <tr :key="index">
              <th>{{ $utils.meta.format('branch', item.Stock) }}{{ item.Code }}</th>
              <td colspan="4">{{ item.Name }}</td>
              <th>{{ item.Unit }}</th>
              <th>{{ item.Amount }}</th>
              <th>{{ item.OrderCode }}</th>
            </tr>
          </template>
          <tr class="blank">
            <th></th>
            <td colspan="4"></td>
            <th></th>
            <th></th>
            <th></th>
          </tr>
          <tr style="height: 64px">
            <th>备注</th>
            <td colspan="7" style="white-space: pre-line; vertical-align: top">{{ parcel.Remark }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="2">审核：</td>
            <td colspan="2">财务：</td>
            <td colspan="2">部门经理：</td>
            <td colspan="2">经办人：</td>
          </tr>
        </tfoot>
      </table>
      <!--附件-->
      <div class="images">
        <template v-for="file in files">
          <el-image fit="cover" :key="file.id" :title="file.name" :src="file.url" lazy :preview-src-list="[file.url]" />
        </template>
      </div>
    </div>
    <!--操作记录-->
    <el-drawer title="操作记录" :visible.sync="drawer" append-to-body>
      <records type="Mall-Parcel" :id="parcel.Id" />
    </el-drawer>
  </div>
</template>

<script>
export default {
  components: {
    vueQr: () => import('vue-qr'),
    records: () => import('@/views/system/record/list')
  },
  props: {
    id: { Type: String }
  },
  data () {
    return {
      loading: false,
      drawer: false,
      parcel: null,
      files: null,
      printObj: {
        id: '#print',
        closeCallback: this.onPrintime,
      }
    }
  },
  created () {
    this.loadData(this.$route.params?.id || this.id)
  },
  methods: {
    onPrintime () {
      this.$confirm(null, '是否记录本次打印信息?', {
        type: 'warning',
        center: true
      }).then(() => {
        this.$apis.mall.parcel.printime({
          id: this.parcel.Id
        }).then(() => {
          this.parcel.Printime += 1
        })
      })
    },

    loadData (id) {
      this.loading = true
      this.$apis.mall.parcel.info({
        id: id,
        goods: true
      }).then(res => {
        this.parcel = res
        return this.$apis.system.file.list({
          objectId: res.Id
        })
      }).then(res => {
        this.files = res
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  .tip {
    border-radius: 0;
    position: relative;
    .btns {
      position: absolute;
      right: 30px;
      bottom: 30px;
    }
  }
  .paper {
    flex: 1;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    padding: 48px;
    table {
      flex: 1;
      min-width: 720px;
    }
    .images {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      .el-image {
        border: 1px solid #ebeef5;
        margin: 8px 8px 0 0;
        width: 160px;
        height: 160px;
      }
    }
  }
}
h1 {
  font-size: 24px;
}

//输出到打印页面
table {
  height: 100%;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid transparent;
  font-size: 12px;
  tr {
    th,
    td {
      word-break: break-all;
      font-weight: normal;
      height: 30px;
      padding: 5px 10px;
    }
    &.blank {
      height: inherit;
    }
  }
  tbody {
    height: 100%;
    tr {
      td,
      th {
        border: 1px solid #000;
      }
    }
  }
  .title {
    position: relative;
    .parcel {
      margin-top: 20px;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      ul {
        li {
          list-style: none;
          display: flex;
          flex-direction: row;
          align-items: center;
          label:nth-child(odd) {
            flex-shrink: 0;
          }
          label:nth-child(even) {
            flex: 1;
          }
          label:nth-child(even) + label:nth-child(odd) {
            margin-left: 20px;
          }
        }
        li + li {
          margin-top: 5px;
        }
      }
    }
    .qr {
      position: absolute;
      right: 0px;
      top: 0px;
    }
  }
}
</style>
